import React from "react";
import {
  Avatar,
  Badge,
  Box,
  Paper,
  Stack,
  Typography,
  Folder2Icon,
  SearchIcon,
  FormBuilderIcon,
} from "convertupleads-theme";
import { EditIcon } from "../../../common/Icons/Icons";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

const BasicAvatar = () => {
  return (
    <Stack spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Basic Avatars
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Box mb={3}>
          <Typography variant="body1" fontSize={14}>
            Avatars Variant
          </Typography>
          <PreviewAndEditor
            language={"js"}
            value={`
            <Stack direction={"row"} spacing={2}>
              <Avatar variant="">H</Avatar>
              <Avatar variant="rounded" sx={{ bgcolor: deepOrange[500] }}>
                N
              </Avatar>
              <Avatar variant="square" sx={{ bgcolor: deepPurple[500] }}>
                OP
              </Avatar>
            </Stack>
          `}
          >
            <Stack direction={"row"} spacing={2}>
              <Avatar variant="">H</Avatar>
              <Avatar variant="rounded" sx={{ bgcolor: "#ff5722" }}>
                N
              </Avatar>
              <Avatar variant="square" sx={{ bgcolor: "#673ab7" }}>
                OP
              </Avatar>
            </Stack>
          </PreviewAndEditor>
        </Box>

        <Box mb={3}>
          <Typography variant="body1" fontSize={14}>
            Avatars Sizes
          </Typography>

          <PreviewAndEditor

            language={"js"}
            value={`
            <Stack direction={"row"} alignItems={"center"} spacing={2}>
              <Avatar size="small">OP</Avatar>
              <Avatar size="medium">OP</Avatar>
              <Avatar size="large">OP</Avatar>
            </Stack>
          `}
          >
            <Stack direction={"row"} alignItems={"center"} spacing={2}>
              <Avatar size="small">OP</Avatar>
              <Avatar size="medium">OP</Avatar>
              <Avatar size="large">OP</Avatar>
            </Stack>
          </PreviewAndEditor>
        </Box>

        <Box mb={3}>
          <Typography variant="body1" fontSize={14}>
            Common usage of Avatar with badge
          </Typography>

          <PreviewAndEditor
            language={"js"}
            value={
              " <Badge\n" +
              "      color={'primary'}\n" +
              "      overlap='circular'\n" +
              "      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}\n" +
              "      badgeContent={<EditIcon sx={{ fontSize: 9 }} />}\n" +
              "  >\n" +
              "      <Avatar size={'large'} alt='Remy Sharp' src='/static/images/avatar/1.jpg' />\n" +
              "</Badge>"
            }
          >
            <Badge
              color={"primary"}
              overlap="circular"
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              badgeContent={<EditIcon sx={{ fontSize: 9 }} />}
            >
              <Avatar
                size={"large"}
                alt="Remy Sharp"
                src="/static/images/avatar/1.jpg"
              />
            </Badge>
          </PreviewAndEditor>
        </Box>

        <Box mb={3}>
          <Typography variant="body1" fontSize={14}>
            Avatars with Badge
          </Typography>

          <PreviewAndEditor
            height={"250px"}
            language={"js"}
            value={`
            <Stack spacing={2}>
              <Stack direction={"row"} alignItems="center" spacing={2}>
                <Box>
                  <Badge
                    color="success"
                    variant="dot"
                    outlined="small"
                    overlap="circular"
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  >
                    <Avatar
                      size="small"
                      alt="Remy Sharp"
                      src="/static/images/avatar/1.jpg"
                    />
                  </Badge>
                </Box>

                <Box>
                  <Badge
                    color="success"
                    variant="dot"
                    overlap="circular"
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  >
                    <Avatar
                      size="medium"
                      alt="Remy Sharp"
                      src="/static/images/avatar/1.jpg"
                    />
                  </Badge>
                </Box>

                <Box>
                  <Badge
                    color="success"
                    variant="dot"
                    overlap="circular"
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  >
                    <Avatar
                      size="large"
                      alt="Remy Sharp"
                      src="/static/images/avatar/1.jpg"
                    />
                  </Badge>
                </Box>
              </Stack>

              <Stack direction={"row"} alignItems="center" spacing={2}>
                <Box>
                  <Badge
                    color="success"
                    variant="dot"
                    overlap="circular"
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  >
                    <Avatar variant="rounded" size="small">
                      OP
                    </Avatar>
                  </Badge>
                </Box>

                <Box>
                  <Badge
                    color="success"
                    variant="dot"
                    overlap="circular"
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  >
                    <Avatar variant="rounded" size="medium">
                      OP
                    </Avatar>
                  </Badge>
                </Box>

                <Box>
                  <Badge
                    color="success"
                    variant="dot"
                    overlap="circular"
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  >
                    <Avatar variant="rounded" size="large">
                      OP
                    </Avatar>
                  </Badge>
                </Box>
              </Stack>

              <Stack direction={"row"} alignItems="center" spacing={2}>
                <Box>
                  <Badge
                    color="success"
                    variant="dot"
                    overlap="circular"
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  >
                    <Avatar variant="square" size="small">
                      OP
                    </Avatar>
                  </Badge>
                </Box>

                <Box>
                  <Badge
                    color="success"
                    variant="dot"
                    overlap="circular"
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  >
                    <Avatar variant="square" size="medium">
                      OP
                    </Avatar>
                  </Badge>
                </Box>

                <Box>
                  <Badge
                    color="success"
                    variant="dot"
                    overlap="circular"
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  >
                    <Avatar variant="square" size="large">
                      OP
                    </Avatar>
                  </Badge>
                </Box>
              </Stack>
            </Stack>
          `}
          >
            <Stack spacing={2}>
              <Stack direction={"row"}  alignItems="center" spacing={2}>
                <Box>
                  <Badge
                    color="success"
                    variant="dot"
                    overlap="circular"
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  >
                    <Avatar
                      size="small"
                      alt="Remy Sharp"
                      src="/static/images/avatar/1.jpg"
                    />
                  </Badge>
                </Box>

                <Box>
                  <Badge
                    color="success"
                    variant="dot"
                    overlap="circular"
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  >
                    <Avatar
                      size="medium"
                      alt="Remy Sharp"
                      src="/static/images/avatar/1.jpg"
                    />
                  </Badge>
                </Box>

                <Box>
                  <Badge
                    color="success"
                    variant="dot"
                    overlap="circular"
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  >
                    <Avatar
                      size="large"
                      alt="Remy Sharp"
                      src="/static/images/avatar/1.jpg"
                    />
                  </Badge>
                </Box>
              </Stack>

              <Stack direction={"row"}  alignItems="center" spacing={2}>
                <Box>
                  <Badge
                    color="success"
                    variant="dot"
                    overlap="circular"
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  >
                    <Avatar variant="rounded" size="small">
                      OP
                    </Avatar>
                  </Badge>
                </Box>

                <Box>
                  <Badge
                    color="success"
                    variant="dot"
                    overlap="circular"
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  >
                    <Avatar variant="rounded" size="medium">
                      OP
                    </Avatar>
                  </Badge>
                </Box>

                <Box>
                  <Badge
                    color="success"
                    variant="dot"
                    overlap="circular"
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  >
                    <Avatar variant="rounded" size="large">
                      OP
                    </Avatar>
                  </Badge>
                </Box>
              </Stack>

              <Stack direction={"row"}  alignItems="center" spacing={2}>
                <Box>
                  <Badge
                    color="success"
                    variant="dot"
                    overlap="circular"
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  >
                    <Avatar variant="square" size="small">
                      OP
                    </Avatar>
                  </Badge>
                </Box>

                <Box>
                  <Badge
                    color="success"
                    variant="dot"
                    overlap="circular"
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  >
                    <Avatar variant="square" size="medium">
                      OP
                    </Avatar>
                  </Badge>
                </Box>

                <Box>
                  <Badge
                    color="success"
                    variant="dot"
                    overlap="circular"
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  >
                    <Avatar variant="square" size="large">
                      OP
                    </Avatar>
                  </Badge>
                </Box>
              </Stack>
            </Stack>
          </PreviewAndEditor>
        </Box>

        <Box mb={3}>
          <Typography variant="body1" fontSize={14}>
            Letter avatars
          </Typography>
          <PreviewAndEditor

            language={"js"}
            value={`
            <Stack direction={"row"} spacing={2}>
              <Avatar>H</Avatar>
              <Avatar sx={{ bgcolor: deepOrange[500] }}>N</Avatar>
              <Avatar sx={{ bgcolor: deepPurple[500] }}>OP</Avatar>
            </Stack>
          `}
          >
            <Stack direction={"row"} spacing={2}>
              <Avatar>H</Avatar>
              <Avatar color={"primary"}>N</Avatar>
              <Avatar color={"primary"}>OP</Avatar>
            </Stack>
          </PreviewAndEditor>
        </Box>

        <Box mb={3}>
          <Typography variant="body1" fontSize={14}>
            Image avatars
          </Typography>
          <PreviewAndEditor

            language={"js"}
            value={
              "              <Avatar\n" +
              '                alt="Remy Sharp"\n' +
              '                src="https://images.unsplash.com/photo-1633332755192-727a05c4013d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=580&q=80"\n' +
              "              />\n" +
              "              <Avatar\n" +
              '                alt="Travis Howard"\n' +
              '                src="https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=580&q=80"\n' +
              "              />\n" +
              "              <Avatar\n" +
              '                alt="Cindy Baker"\n' +
              '                src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=387&q=80"\n' +
              "              />"
            }
          >
            <Stack direction={"row"} spacing={2}>
              <Avatar
                alt="Remy Sharp"
                src="https://images.unsplash.com/photo-1633332755192-727a05c4013d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=580&q=80"
              />
              <Avatar
                alt="Travis Howard"
                src="https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=580&q=80"
              />
              <Avatar
                alt="Cindy Baker"
                src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=387&q=80"
              />
            </Stack>
          </PreviewAndEditor>
        </Box>

        <Box mb={3}>
          <Typography variant="body1" fontSize={14}>
            Icon avatars
          </Typography>
          <PreviewAndEditor

            language={"js"}
            value={`
            <Stack direction={"row"} spacing={2}>
              <Avatar>
                <Folder2Icon />
              </Avatar>
              <Avatar sx={{ bgcolor: "#e91e63" }}>
                <SearchIcon />
              </Avatar>
              <Avatar sx={{ bgcolor: "#4caf50" }}>
                <FormBuilderIcon />
              </Avatar>
            </Stack>
          `}
          >
            <Stack direction={"row"} spacing={2}>
              <Avatar>
                <Folder2Icon />
              </Avatar>
              <Avatar sx={{ bgcolor: "#e91e63" }}>
                <SearchIcon />
              </Avatar>
              <Avatar sx={{ bgcolor: "#4caf50" }}>
                <FormBuilderIcon />
              </Avatar>
            </Stack>
          </PreviewAndEditor>
        </Box>
      </Paper>
    </Stack>
  );
};

export default BasicAvatar;
